<template>
	<v-card
		elevation="0"
		outlined
		max-width="55%"
		:color="color"
		:class="cardClasses"
	>
		<v-card-text class="pt-1 pb-0 d-flex">
			<span class="subtitle-2">
				{{ senderName }}
			</span>
			<v-spacer />
			<span class="caption">
				{{ $formatDateTime(message.created_at) }}
			</span>
		</v-card-text>
		<v-card-text class="pb-2 pt-0">
			{{ message.content }}
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'RepairOrderMessageCard',
	props: {
		message: {
			type: Object,
			required: true,
			defaultClasses: [],
		},
	},
	computed: {
		sentFromUser() {
			return this.message.sender_type === 'user';
		},
		cardClasses() {
			const classes = [
				'mb-2', 'rounded',
			];

			if (this.sentFromUser) {
				classes.push('ml-auto');
			}

			return classes;
		},
		color() {
			if (this.message.recentlyCreated) {
				return 'green lighten-5';
			}
			if (!this.sentFromUser) {
				return 'grey lighten-3';
			}
			return '';
		},
		senderName() {
			return this.sentFromUser ? 'SpaClean' : 'Инициатор';
		},
	},
};
</script>

<style scoped>

</style>
